<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="toc">
<h2 class="contentsHead">Contents</h2>
<p class="contentsEntry"><a href="#/KingofAirfighters_preface#preface">Preface</a></p>
<p class="contentsEntry"><a href="#/KingofAirfighters_introduction#introduction">Introduction</a></p>
<table class="table">
<tbody><tr valign="top">
<td align="left"><a href="#/KingofAirfighters_part1#part1">I</a></td>
<td><span class="space"> </span></td>
<td align="left"><a href="#/KingofAirfighters_part1#part1">EARLY LIFE—PART I</a></td>
</tr>
<tr valign="top">
<td><span class="space1"></span></td>
</tr>
<tr valign="top">
<td align="left"><a href="#/KingofAirfighters_part2#part2">II</a></td>
<td><span class="space"> </span></td>
<td align="left"><a href="#/KingofAirfighters_part2#part2">EARLY LIFE—PART II</a></td>
</tr>
<tr valign="top">
<td><span class="space1"></span></td>
</tr>
<tr valign="top">
<td align="left"><span href="#/KingofAirfighters_part3#part3" title="Link target outside of Sample">III</span></td>
<td><span class="space"> </span></td>
<td align="left"><span href="#/KingofAirfighters_part3#part3" title="Link target outside of Sample">LEARNING TO FLY, AND FIRST FIRST OF DUTY IN FRANCE WITH NO. 40 SQUADRON</span></td>
</tr>
<tr valign="top">
<td><span class="space1"></span></td>
</tr>
<tr valign="top">
<td align="left"><span href="#/KingofAirfighters_part4#part4" title="Link target outside of Sample">IV</span></td>
<td><span class="space"> </span></td>
<td align="left"><span href="#/KingofAirfighters_part4#part4" title="Link target outside of Sample">SECOND TOUR OF DUTY IN FRANCE WITH NOS. 74 AND 85 SQUADRONS</span></td>
</tr>
<tr valign="top">
<td><span class="space1"></span></td>
</tr>
<tr valign="top">
<td align="left"><span href="#/KingofAirfighters_part5#part5" title="Link target outside of Sample">V</span></td>
<td><span class="space"> </span></td>
<td align="left"><span href="#/KingofAirfighters_part5#part5" title="Link target outside of Sample">KING OF AIRFIGHTERS</span></td>
</tr>
<tr valign="top">
<td><span class="space1"></span></td>
</tr>
<tr valign="top">
<td align="left"><span href="#/KingofAirfighters_part6#part6" title="Link target outside of Sample">VI</span></td>
<td><span class="space"> </span></td>
<td align="left"><span href="#/KingofAirfighters_part6#part6" title="Link target outside of Sample">L’ENVOI</span></td>
</tr>
</tbody></table>
<p class="contentsEntry"><span href="#/KingofAirfighters_acknowledgments#acknowledgments" title="Link target outside of Sample">Author’s Acknowledgements</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KingofAirfighters_toc.vue?3d959866